import { ArrowDownward, ArrowDropDown, ArrowDropUp, ArrowUpward } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { increment } from 'firebase/firestore';
import React, { FC } from 'react';
import styles from './NumberArrowSelector.module.css';

interface NumberArrowSelectorProps {
    value: number;
    label: string;
    min: number;
    max: number;
    increment: () => void;
    decrement: () => void
}

const NumberArrowSelector: FC<NumberArrowSelectorProps> = ({ value, label, min, max, increment, decrement }) => {

    return (
        <div className={styles.NumberArrowSelector} data-testid="NumberArrowSelector">
            <div className={styles.button}>
                <IconButton disabled={value >= max} size="small" onClick={increment} color="primary" aria-label="Omhoog" component="span">
                    <ArrowDropUp></ArrowDropUp>
                </IconButton>
            </div>
            <div className={styles.value}>
                {value}
            </div>
            <div className={styles.button}>
                <IconButton disabled={value <= min} size="small" onClick={decrement} color="primary" aria-label="Omlaag" component="span">
                    <ArrowDropDown></ArrowDropDown>
                </IconButton>
            </div>
            <div className={styles.label}>
                {label}
            </div>
        </div>
    )
};

export default NumberArrowSelector;
